import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

interface StepNavigationProps {
    isFirstStep?: boolean;
    isLastStep: boolean;
    onBack: () => void;
    isSubmitting?: boolean;
    disableNext?: boolean;
}

export const StepNavigation = ({
    isFirstStep,
    isLastStep,
    onBack,
    isSubmitting = false,
    disableNext = false,
}: StepNavigationProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                my: 2,
                gap: { xs: 2, sm: 2 },
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            }}
        >
            <Button
                onClick={onBack}
                disabled={isFirstStep || isSubmitting}
                startIcon={<ArrowBack sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />}
                variant="outlined"
                sx={{
                    order: { xs: 2, sm: 1 },
                    width: { xs: '100%', sm: 'auto' },
                }}
            >
                Back
            </Button>

            {isLastStep ? (
                <Button
                    type="submit"
                    disabled={isSubmitting || disableNext}
                    variant="contained"
                    color="primary"
                    sx={{
                        order: { xs: 1, sm: 2 },
                        width: { xs: '100%', sm: 'auto' },
                    }}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                </Button>
            ) : (
                <Button
                    type="submit"
                    loading={isSubmitting}
                    loadingPosition="start"
                    disabled={isSubmitting || disableNext}
                    endIcon={<ArrowForward sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />}
                    variant="contained"
                    color="primary"
                    sx={{
                        order: { xs: 1, sm: 2 },
                        width: { xs: '100%', sm: 'auto' },
                    }}
                >
                    Next
                </Button>
            )}
        </Box>
    );
};
